var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "component-body",
      class: {
        "menu-non-expanded": !_vm.menuExpanded,
        "menu-expand-container": true
      }
    },
    [
      _c("nav", [
        _c(
          "div",
          { staticClass: "menu-header", on: { click: _vm.toggleMenu } },
          [
            _c("i", { staticClass: "far fa-bars icon-toggle" }),
            _vm._v(" "),
            _vm.menuExpanded &&
            _vm.usuario &&
            _vm.usuario.perfilSelecionado &&
            _vm.usuario.perfilSelecionado.setor
              ? _c("h4", { staticClass: "module-text" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.usuario.perfilSelecionado.setor.nome) +
                      "\n      "
                  )
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.items, function(item) {
            return _vm.mostrarMenu(item.permissao)
              ? _c(
                  "li",
                  { key: item.id },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "dark",
                          content: item.nome,
                          disabled:
                            item.nome.length < 26 && _vm.windowWidth > 1365,
                          placement: "right"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "menu-item",
                            class: { active: _vm.caixaIsActive(item) },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.goTo(item.routeGroup)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "menu-group color-primary",
                                attrs: { id: "menu-side-" + item.routeGroup }
                              },
                              [
                                _c("i", { class: item.icon }),
                                _vm._v(" "),
                                _c("div", { staticClass: "menu-text" }, [
                                  _c("p", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          item.nome.length > 25
                                            ? item.nome.slice(0, 25) + "..."
                                            : item.nome
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e6d85b52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6d85b52","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/layout/SideMenu/SideMenu.vue
// module id = null
// module chunks = 